import formatDate from 'helpers/formatDate';

import { metadataProps } from '../metadataPropTypes';
import shouldRenderValue from 'helpers/shouldRenderValue';
import { Meta } from '../Metadata.style';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';

/**
 * This component shows meta data of a track.
 */
function TrackMetadata(props) {
  const {
    releaseDate,
    primaryArtist,
    showDetailedMetadata,
    displayName,
    topic,
    isrcTooltipContent,
    isrc_list,
  } = props;

  const isrcValue = isrc_list
    ? isrc_list?.length === 1
      ? isrc_list[0]
      : `${isrc_list[0]}, ...`
    : '';

  return (
    <Meta>
      {topic && topic.includes('social')
        ? shouldRenderValue(displayName) && <span>{displayName}</span>
        : shouldRenderValue(primaryArtist) && (
            <span>{`${
              showDetailedMetadata ? 'Track ' : ''
            }by ${primaryArtist}`}</span>
          )}
      {shouldRenderValue(releaseDate) && (
        <span>{`${formatDate(releaseDate, 'day-short')}`}</span>
      )}
      {shouldRenderValue(isrcValue) && (
        <TippyToolTip
          enabled={isrcTooltipContent}
          tooltipContent={isrcTooltipContent}
          placement="right"
          zIndex="10000"
          canBeCopied
          maxHeight="210px"
        >
          <span className="versionsSpan">{`ISRC: ${isrcValue}`}</span>
        </TippyToolTip>
      )}
    </Meta>
  );
}

TrackMetadata.propTypes = {
  ...metadataProps,
};

export default TrackMetadata;
